import RulesAndRegulations from "../components/pages/Rules&Regulations";

export default RulesAndRegulations;
